const state = {
  currentStep: 1,
  secondStepWindow: 'address',
  currentPaymentTab: 'paymentTypes',
  currentOtherWindow: undefined,
  showFoodWindow: false,
  courierComment: '',
  currentMenuItem: null,
  currentCategory: null,
  currentCollectionId: undefined,
  categories: null,
  client: null,
  showPromotionsWindow: false,
  showCommentKeyboard: false,
  isMenuItemsLoading: false,
  menuItemsList: [],
  collectionsList: [],
  newClientPhone: null,
  newOrderClientId: null,
  clientAddress: {},
  orderId: null,
  // при редактировании режим оплаты переключили на «оплатить сейчас» - после закрытия формы нужен диалог оплаты
  payNowSelected: false,
  currentOrder: {},
  isDrinksSuggested: false,
  isSauceSuggested: false,
  searchMenu: '',
  availableSteps: [],
}

const getters = {
  getClientStreet: (state) => {
    let address = ''
    if (state.clientAddress) {
      address += state.clientAddress.shortCity ? `${state.clientAddress.shortCity}, ` : ''
      address += state.clientAddress.street
    }
    return address
  },
  getClientHouse: (state) => {
    return state.clientAddress ? state.clientAddress.house : ''
  },
  getClientFloor: (state) => {
    return state.clientAddress ? state.clientAddress.floor : ''
  },
  getClientEntry: (state) => {
    return state.clientAddress ? state.clientAddress.entry : ''
  },
  getClientApartmentNumber: (state) => {
    return state.clientAddress ? state.clientAddress.apartmentNumber : ''
  },
  getClientDoorCode: (state) => {
    return state.clientAddress ? state.clientAddress.doorCode : ''
  },
  getAllMenuItems: state => {
    const items = []
    state.categories.forEach(category => items.push(...category.menuItems))
    return items
  },
  getAddress: (state) => {
    return state.clientAddress ? state.clientAddress : {}
  },
  getOrderFilial: (state) => {
    return state.currentOrder ? state.currentOrder.filial : {}
  },
}

const actions = {

}

const mutations = {
  setSearchMenu (state, value) {
    state.searchMenu = value
  },
  setOrder (state, value) {
    state.currentOrder = JSON.parse(JSON.stringify(value))
  },
  setFoodWindowState (state, value) {
    state.showFoodWindow = value
  },
  setOrderId (state, value) {
    state.orderId = value
  },
  setPayNowSelected (state, value) {
    state.payNowSelected = value
  },
  setClientAddress (state, value) {
    state.clientAddress = value
  },
  setDrinkDetailsStatus (state, value) {
    state.isDrinksSuggested = value
  },
  setSauceDetailsStatus (state, value) {
    state.isSauceSuggested = value
  },
  setNewOrderClientId (state, value) {
    state.newOrderClientId = value
  },
  setCurrentOtherWindow (state, value) {
    state.currentOtherWindow = value
  },
  closeOtherAndPromoWindows (state) {
    state.currentOtherWindow = undefined
    state.showPromotionsWindow = false
  },
  setCurrentPaymentTab (state, value) {
    state.currentPaymentTab = value
  },
  toggleCommentKeyboard (state, value) {
    state.showCommentKeyboard = value
  },
  setCourierComment (state, value) {
    state.courierComment = value
  },
  setStep (state, step) {
    state.availableSteps.push(step)
    state.currentStep = step
  },
  setCurrentClient (state, payload) {
    state.client = payload
  },
  setSecondStepWindow (state, value) {
    state.secondStepWindow = value
  },
  togglePromotionsWindow (state, value) {
    state.showPromotionsWindow = value
  },
  realTogglePromotionsWindow (state) {
    state.showPromotionsWindow = !state.showPromotionsWindow
  },
  setMenuItemsLoading (state, value) {
    state.isMenuItemsLoading = value
  },
  setCurrentCollectionId (state, value) {
    state.currentCollectionId = value
  },
  setCollectionsList (state, value) {
    state.collectionsList = value
  },
  setCategories (state, categories) {
    state.categories = categories
  },
  setCurrentCategory (state, id) {
    state.currentCategory = id
  },
  setMenuItemsList (state, payload) {
    state.menuItemsList = payload
  },
  setNewClientPhone (state, value) {
    state.newClientPhone = value
  },
  resetAvailableSteps (state) {
    state.availableSteps = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
